module.exports = __webpack_public_path__ + "cc512f8ad142fce993581a437c8e0df3.png";